import axiosInstance from "../instance/axiosInstance";

class ProfileApi {
  static async updateProfile(formData) {
    try {
      const response = await axiosInstance.post("/update/profile", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      return error;
    }
  }
  static async passwordReset(formData) {
    try {
      const response = await axiosInstance.post("/update/password", formData);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
}

export default ProfileApi;
